<template>
  <div class="message-item">
    <div
      :class="[message.readStatus === '1' ? 'text-[var(--color-text-secondary)]' : 'text-[var(--color-text-primary)]']"
    >
      <!-- {{ message.applicantName ? `${message.applicantName}&nbsp;&nbsp;&nbsp;&nbsp;` : '' }} -->
      {{ truncateMessage(message.title) }}
    </div>
    <div :class="['flex', 'justify-between', 'mt-8px', 'text-[var(--color-text-secondary)]']">
      <div>{{ message.typeName || '-' }}</div>
      <div>{{ getDayDiff(message.createTime) }}</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import dayjs from 'dayjs';
import { truncate } from 'lodash-es';
import { ISysMessage } from '@/api/system/sysMessage';

const props = defineProps({
  message: {
    type: Object as PropType<ISysMessage>,
    required: true,
  },
});

const { message } = toRefs(props);

/** 计算时间差 */
function getDayDiff(time: Date) {
  if (!time) return '-';
  const minuteDiff = dayjs().diff(dayjs(time), 'minutes');
  if (minuteDiff < 1) {
    return '刚刚';
  } else if (minuteDiff < 60) {
    return minuteDiff + '分钟前';
  }
  const hourdiff = dayjs().diff(dayjs(time), 'hours');
  if (hourdiff < 24) {
    return hourdiff + '小时前';
  }
  const daydiff = dayjs().diff(dayjs(time), 'days');
  if (daydiff > 0 && daydiff < 30) {
    return daydiff + '天前';
  }
  const monthdiff = dayjs().diff(dayjs(time), 'months');
  const sameYear = dayjs().year() === dayjs(time).year();
  if (monthdiff > 0 && monthdiff < 3) {
    return monthdiff + '月前';
  } else if (monthdiff >= 3 && monthdiff < 12 && sameYear) {
    return dayjs(time).format('MM-DD');
  }
  return dayjs(time).format('YYYY-MM-DD');
}

/** 截取消息 */
function truncateMessage(message: string) {
  if (!message) return '-';
  return truncate(message, { length: 35, omission: '...' });
}
</script>

<style lang="scss" scoped>
.message-item {
  font-size: 14px;
  line-height: 22px;
}
</style>
